import { render, staticRenderFns } from "./ActionComponent.vue?vue&type=template&id=11835b4c&"
import script from "./ActionComponent.vue?vue&type=script&lang=ts&"
export * from "./ActionComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports